export default "__VITE_ASSET__CkUj3CBr__"